'use client';

import { c as _c } from "react/compiler-runtime";
import { useStatusBarColor } from '@/hooks/useStatusBarColor';
import { useAuthStore } from '@/stores/AuthStore';
import { STATUS_COLOR } from '@/stores/DeviceStore';
export const Header = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      color: STATUS_COLOR.LUCKY_BALL_MAIN
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useStatusBarColor(t0);
  const nickName = useAuthStore(_temp);
  let t1;
  if ($[1] !== nickName) {
    t1 = <div className="sticky top-0 z-[2] flex min-h-48 items-center justify-between bg-transparent px-20 pt-[var(--safe-area-top,0px)] backdrop-blur-md"><p className="font-700 text-Gray-900 typo-body2">{nickName}님</p></div>;
    $[1] = nickName;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
function _temp(state) {
  return state.myInfo?.nickName;
}